import { useMutation, useQuery } from '@apollo/client';
// import { GET_NOTIFICATIONS } from '../../../graphql/common/queries';
import React, { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { NotificationType } from '../../../types/types';
import {
	ScrollView,
	StyleSheet,
	Text,
	TouchableOpacity,
	View,
} from 'react-native';
import { palettes } from '../../../config';
import { useIsSpecificViewportWidth } from '../../../hooks/useIsSpecificViewportWidth';
import { TStyle, TStyleInputOrText } from '../../../types/TStyle';
import { getResponsiveStyle } from '../../../utils/getResponsiveStyle';
import { NotificationBellIcon } from '../icons';
import SectionHeading from '../SectionHeading';
import Loader from '../loader/Loader';
import { GET_ALL_NOTIFICATIONS } from '../../../graphql/notification/queries';
import {
	DELETE_ALL_NOTIFICATIONS,
	READ_NOTIFICATIONS,
} from '../../../graphql/notification/mutations';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { setNoOfNotifications } from '../../../redux/notificationSlice';

import NotAvailableMessage  from '../not-available-message/NotAvailableMessage';
import NotificationLayouts from './NotificationLayouts';
import { useSetAlert } from '../../../hooks/useSetAlerts';

const NotificationIconWithDropdown = () => {
	const { isLessThanDesktopBase } = useIsSpecificViewportWidth();

	const [open, setOpen] = useState(false);
	const dispatch = useAppDispatch();
	const { loading: notificationLoading, data: notificationData } = useQuery(
		GET_ALL_NOTIFICATIONS
	);

	// console.log(notificationData);

	const notifications_: [NotificationType] =
		notificationData?.getAllNotifications?.data?.data;
	// console.log(notifications);

	const [notifications, setNotifications] = useState<any>([]);

	const noOfRead = useAppSelector(state => state.notification.noOfNotifications);
	const [viewAll, setViewAll] = useState(false);

	const { setAlert } = useSetAlert();
	if (notifications_ && notifications.length !== notifications_.length) {
		setNotifications(notifications_);
	}
	const [readNotifications] = useMutation(READ_NOTIFICATIONS, {
		onCompleted: () => {
			dispatch(setNoOfNotifications(0));
			// console.log(data);
		},
	});

	const [deleteAllNotifications, { loading: deleteLoading }] = useMutation(
		DELETE_ALL_NOTIFICATIONS,
		{
			awaitRefetchQueries: true,
			refetchQueries: [{ query: GET_ALL_NOTIFICATIONS }],
			onCompleted: data => {
				if (data && data.deleteAllNotifications.success) {
					setAlert(
						'All Notifications successfully deleted',
						'normal'
					);
				} else {
					setAlert('Could not delete notifications', 'danger');
				}
			},
			onError: () => {
				setAlert('Could not delete notifications', 'danger');
			},
		}
	);
	const aDay = 86400000;
	const twoDays = 172800000;
	const todayNotification =
		notifications &&
		notifications.length > 0 &&
		notifications.filter(
			(not: NotificationType) => Date.now() - Number(not.createdAt) < aDay
		);
	const yesterdayNotifications =
		notifications &&
		notifications.length > 0 &&
		notifications.filter(
			(notification: NotificationType) =>
				Date.now() - Number(notification.createdAt) >= aDay &&
				Date.now() - Number(notification.createdAt) < twoDays
		);

	const moreNotifications =
		notifications &&
		notifications.length > 0 &&
		notifications.filter(
			(notification: NotificationType) =>
				Date.now() - Number(notification.createdAt) >= twoDays
		);

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<View
				style={[
					styles.container,
					styles.notificationIconContainer,
					styleNotificationIconContainer(isLessThanDesktopBase),
				]}
			>
				<NotificationBellIcon
					onPressIcon={() => {
						setOpen(prev => !prev);
						readNotifications();
					}}
					style={styleNotificationBellIcon()}
				/>
				{open && (
					<View
						style={[
							styles.dropdownContainer,
							styleDropdownContainer(),
						]}
					>
						{notificationLoading || deleteLoading ? (
							<Loader />
						) : (
							<>
								<TouchableOpacity
									style={styles.notificationHeading}
								>
									<SectionHeading
										heading={'Notifications'}
										size="small"
										containerStyles={styleHeading()}
									/>
									{notifications &&
										notifications.length > 0 &&
										(moreNotifications.length > 0 ? (
											<Text
												onPress={() =>
													!viewAll &&
													(todayNotification.length >
														0 ||
														yesterdayNotifications.length >
															0)
														? setViewAll(!viewAll)
														: deleteAllNotifications()
												}
												style={{
													color: palettes.grey[1],
													paddingRight: 20,
													marginTop: 10,
												}}
											>
												{viewAll
													? 'Clear All'
													: todayNotification.length >
															0 ||
													  yesterdayNotifications.length >
															0
													? 'View All'
													: 'Clear All'}
											</Text>
										) : (
											<Text
												onPress={() =>
													deleteAllNotifications()
												}
												style={{
													color: palettes.grey[1],
													paddingRight: 20,
													marginTop: 10,
												}}
											>
												Clear All
											</Text>
										))}
								</TouchableOpacity>
								{notifications.length > 0 ? (
									<ScrollView
										contentContainerStyle={{
											height: '50vh',
										}}
									>
										{todayNotification.length > 0 && (
											<View style={styles.dateHeader}>
												<Text style={styles.dateText}>
													Today
												</Text>
											</View>
										)}

										<>
											{notifications &&
												notifications.length > 0 &&
												// show notification based on type
												todayNotification.map(
													(
														notification: NotificationType
													) => {
														return (
															<NotificationLayouts
																notification={
																	notification
																}
															/>
														);
													}
												)}
										</>

										{yesterdayNotifications.length > 0 && (
											<View style={styles.dateHeader}>
												<Text style={styles.dateText}>
													Yesterday
												</Text>
											</View>
										)}

										{/* yesterday's notifications */}

										<>
											{notifications &&
												notifications.length > 0 &&
												// show notification based on type
												yesterdayNotifications.map(
													(
														notification: NotificationType
													) => {
														return (
															<NotificationLayouts
																notification={
																	notification
																}
															/>
														);
													}
												)}
										</>
										{viewAll && (
											<View style={styles.dateHeader}>
												<Text style={styles.dateText}>
													More
												</Text>
											</View>
										)}
										<>
											{(notifications && viewAll) ||
											(todayNotification.length === 0 &&
												yesterdayNotifications.length ===
													0 &&
												notifications.length > 0)
												? // show notification based on type
												  moreNotifications.map(
														(
															notification: NotificationType
														) => {
															return (
																<NotificationLayouts
																	notification={
																		notification
																	}
																/>
															);
														}
												  )
												: null}
										</>
									</ScrollView>
								) : (
									<View style={{ marginLeft: 25 }}>
										<NotAvailableMessage message="No notification" />
									</View>
								)}
							</>
						)}
					</View>
				)}
				{noOfRead !== 0 && (
					<Text
						style={[
							styles.notifications,
							styleNewNotification(),
						]}
					>
						{noOfRead < 10 ? `0${noOfRead}` : noOfRead}
					</Text>
				)}
			</View>
		</ClickAwayListener>
	);
};

function styleNewNotification() {
	return {
		marginLeft: getResponsiveStyle(2),
		marginRight: getResponsiveStyle(20),
		fontSize: getResponsiveStyle(12, 'font'),
		lineHeight: getResponsiveStyle(14, 'font'),
		color: palettes.purple[0],
	};
}

function styleHeading(): TStyleInputOrText {
	return {
		paddingHorizontal: getResponsiveStyle(24),
		paddingTop: getResponsiveStyle(24),
		marginBottom: getResponsiveStyle(14),
	};
}

function styleNotificationBellIcon() {
	return {
		width: getResponsiveStyle(20, 'dimensions'),
		height: getResponsiveStyle(20, 'dimensions'),
	};
}

function styleNotificationIconContainer(
	isLessThanDesktopBase: boolean
): TStyle {
	return {
		paddingRight: isLessThanDesktopBase ? 0 : getResponsiveStyle(21),
		borderRightWidth: isLessThanDesktopBase ? 0 : 1,
	};
}

function styleDropdownContainer(): TStyle {
	return {
		minHeight: getResponsiveStyle(224, 'dimensions'),
		width: getResponsiveStyle(320, 'dimensions'),
		minWidth: getResponsiveStyle(320, 'dimensions'),
		top: getResponsiveStyle(50, 'dimensions'),
		paddingBottom: getResponsiveStyle(8),
		right: 0,
	};
}

export default NotificationIconWithDropdown;

const styles = StyleSheet.create({
	notifications: {
		fontWeight: '600',
	},
	eventContainer: {
		borderTopWidth: 1,
		borderTopColor: palettes.grey[5],
	},
	eventHeadingStyle: {
		fontWeight: '600',
	},
	container: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		marginLeft: getResponsiveStyle(21),
	},
	dateHeader: {
		paddingHorizontal: getResponsiveStyle(25),
		paddingVertical: getResponsiveStyle(13),
		borderTopColor: palettes.grey[5],
		borderTopWidth: 1,
	},
	notificationHeading: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
		alignContent: 'center',
		alignItems: 'center',
	},
	dateText: {
		fontSize: getResponsiveStyle(12, 'font'),
		fontWeight: '600',
		lineHeight: getResponsiveStyle(16, 'font'),
		color: palettes.dark[4],
	},
	dropdownContainer: {
		height: 'fit-content',
		position: 'absolute',
		zIndex: 9999,
		backgroundColor: 'white',
		borderWidth: 1,
		borderColor: palettes.grey[5],
		shadowOffset: {
			width: 0,
			height: 30,
		},
		shadowRadius: 40,
		shadowColor: 'rgba(124, 136, 155, 0.18)',
		shadowOpacity: 1,
		borderRadius: 6,
	},
	notificationIconContainer: {
		borderRightColor: palettes.grey[7],
	},
	gradientBox: {
		width: '100%',
		height: 70,
		position: 'absolute',
		bottom: 0,
	},
});
